module.exports = __webpack_public_path__ + "img/cmp_chao.cda69af1.png";